import React from "react";
import "./style.css";

const Button1 = () => {
  return (
    <div>
      <button className="button1-main">
        
        <span className="button1-text">Login/Sign Up</span>
        <span className="button1-blob button1-blob1"></span>
        <span className="button1-blob button1-blob2"></span>
        <span className="button1-blob button1-blob3"></span>
        <span className="button1-blob button1-blob4"></span>
      </button>
    </div>
  );
};

export default Button1;
